<template>
  <div class='CategoriasProd'>
    <div class="cont-categ">
      <div class="header">{{ Empresa.modelo === 'Modelo 03' ? 'Categorias das captações' : 'Categorias' }}</div>
      <div class="cont">
        <input-categ
        v-for="(categ, key) in Categorias.filter(c  => c.name !== '')"
        :key="key"
        :data="categ"
        :checkbox="false"
        @edit:catecogia="ShowAddCateg=true"
        />
      </div>
    </div>
    <div>
      <div class="btn" @click="toggleAdd">
      +Adicionar nova Categoria
      </div>
      <div v-if="ShowAddCateg">
        <input-icon-categ
        @click="SetModal({ component: 'SelectIcon', active: true, callback: 'SetIcon' })"
        />
        <input-reg
        :value="SelectedCategEdit.name"
        @update:model-value="newValue => changeCategEdit({ name: newValue })"
        text="Nome da Categoria"
        :label="{ marginLeft: '5px', textAlign: 'left', marginTop: '5px' }"
        :input="{ width: '95%', border: 'thin solid #CCCCCC', borderRadius: '5px', padding: '2%', fontSize: '16px' }"
        />
        <div>
          <button
          @click="handleCateg"
          >
            Salvar categoria
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputCateg from '../Register/InputCateg'
import InputReg from '../Register/InputReg'
import InputIconCateg from '../Register/InputIconCateg'
export default {
  name: 'CategoriasProd',
  components: { InputCateg, InputReg, InputIconCateg },
  data () {
    return {
      ShowAddCateg: false
    }
  },
  computed: {
    ...mapGetters(['Categorias', 'SelectedCategEdit', 'Empresa'])
  },
  methods: {
    ...mapActions(['PushCateg', 'SetModal', 'GetCategory', 'changeCategEdit', '_UpdateCategory']),
    clearCateg () {
      return this.changeCategEdit({ id: '', name: '', icon: '', active: false })
    },
    toggleAdd () {
      // "+Adicionar" sempre abre o formulário vazio, mesmo depois de clicar em editar
      if(!this.ShowAddCateg || this.SelectedCategEdit.id !== '') {
        this.clearCateg()
        this.ShowAddCateg = true
        return
      }
      this.ShowAddCateg = false
    },
    handleCateg () {
      if(this.SelectedCategEdit.name.trim() === '') return
      if(this.SelectedCategEdit.id !== '') {
        this._UpdateCategory(this.SelectedCategEdit)
          .then(() => this.GetCategory())
          .then(() => this.clearCateg())
      } else {
        this.PushCateg({
          active: false,
          name: this.SelectedCategEdit.name,
          icon: this.SelectedCategEdit.icon
        })
        .then(() => this.clearCateg())
      }
    }
  },
  created () {
    this.clearCateg()
    this.GetCategory()
  }
}
</script>

<style scoped>
/* a área do painel tem altura fixa; a página rola por conta própria para mostrar o formulário */
.CategoriasProd {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  padding: 1% 1.5% 20px;
}

.CategoriasProd > div {
  width: 50%;
}

.cont-categ {
  height: 400px;
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.header {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
}

.cont {
  height: 88%;
  padding: 1%;
  overflow: auto;
  box-sizing: border-box;
}

.btn {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

button {
  border: 0;
  padding: 10px 15px;
  font-size: 12px;
  margin-top: 10px;
  border-radius: 2px;
  background-color: #CCCCCC;
  cursor: pointer;
}

@media (max-width: 500px) {
  .CategoriasProd > div {
    width: 100%;
  }
}
</style>
